import axios from 'axios';

const API_URL = 'https://dev-api.thoorigai.net/api/v1/wishlist';

const handleApiError = (error) => {
  if (error.response?.data) {
    return error.response.data;
  }
  return { success: false, message: 'An error occurred' };
};

export const createWishlistItem = async (itemData) => {
  try {
    const response = await axios({
      url: `${API_URL}/create-wishlist-item`,
      method: 'POST',
      data: itemData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getAllWishlistItems = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/get-all-wishlist-items`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getWishlistItemById = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/get-wishlist-item/${id}`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteWishlistItem = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/delete-wishlist-item/${id}`,
      method: 'DELETE',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

const wishlistService = {
  createWishlistItem,
  getAllWishlistItems,
  getWishlistItemById,
  deleteWishlistItem,
};

export default wishlistService;
